export const API_CALL_FAILED = "API_CALL_FAILED";
export const ADD_ALERT   = "ADD_ALERT";
export const CLOSE_ALERT = "CLOSE_ALERT";

export const UPDATE_COMMENT_LOCAL = "UPDATE_COMMENT_LOCAL";
export const UPDATE_COMMENT_REMOTE = "UPDATE_COMMENT_REMOTE";